import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useResetPassword = () => {
const prefix = process.env.REACT_APP_PUBLIC_PREFIX || '';
  return useMutation({
    mutationFn: async (input) => {
      const result = await restClient({
        url: `${prefix}/public/auth/reset-password`,
        method: 'POST',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch user groups list after successful creation
    }
  });
};